function ensureGtag() {
    if (typeof window === 'undefined')
        return;
    const w = window;
    w.dataLayer = w.dataLayer ?? [];
    w.gtag =
        w.gtag ??
            function (...args) {
                w.dataLayer.push(args);
            };
}
export function registerGA4(opts) {
    if (typeof window === 'undefined' || typeof document === 'undefined')
        return;
    ensureGtag();
    // Consent Mode v2: default denied
    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied',
        security_storage: 'granted',
    });
    const s1 = document.createElement('script');
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(opts.measurementId)}`;
    document.head.appendChild(s1);
    window.gtag('js', new Date());
    window.gtag('config', opts.measurementId, { anonymize_ip: true });
}
//# sourceMappingURL=ga4.js.map